import { Company } from '@aibees/elephant/feature/search-table-company';
import { hasNoCompanyDataAvailable } from '@aibees/elephant/utils';
import { useMemo } from 'react';
import { PeopleTableInfo } from '../../feature/search-table-people/types';

export function usePersonCompanyInfo(data?: PeopleTableInfo) {
  return useMemo(() => {
    if (!data)
      return {
        companyName: undefined,
        id: undefined,
        imageSrc: undefined,
        socialLink: undefined,
        showPopover: false,
      };

    const fallbackPosition = data.positionGroups?.[0];

    const companyName = data.company
      ? data.company.summary?.name ?? undefined
      : fallbackPosition?.company?.name ?? undefined;

    const id = data.company
      ? data.company.id ?? undefined
      : fallbackPosition?.company?.id ?? undefined;

    const imageSrc = data.company
      ? data.company.summary?.logo?.source ?? undefined
      : fallbackPosition?.company?.logo ?? undefined;

    const socialLink = data.company
      ? data.company?.link ?? undefined
      : fallbackPosition?.company?.url
      ? ({ linkedin: fallbackPosition.company.url } as Company['link'])
      : undefined;

    const hasNoCompanyDataAvailableValue = hasNoCompanyDataAvailable(
      data.company
    );

    const showPopover = !!(companyName || id || hasNoCompanyDataAvailableValue);

    return {
      companyName,
      showPopover,
      imageSrc,
      id,
      socialLink,
    };
  }, [data]);
}
